<template>
  <!-- 分账单管理 -->
  <div>
    <app-page>
      <template #fheader>
        <div class="fan-search margin-bottom-8">
          <jr-search2
            ref="searchForm"
            :form-list="formList"
            :search-value.sync="queryForm"
            :loading="loading"
            @search="handleSearch"
            @reset="handleReset"
            trackCode="subAccountManageList-1"
          >
            <template slot="batch-search-btn">
              <el-button
                type="primary"
                :size="formSize"
                :loading="loading"
                @click="handleBatchSearch()"
              >
                批量查询
              </el-button>
            </template>
          </jr-search2>
        </div>
      </template>
      <template #header>
        <div class="fan-search">
          <page-select-groups :search-value.sync="queryForm" @change="refreshList" :selectList="selectList">
            <template #sourceList>
              <page-source-select
                title="归属业务"
                :sources="sourceList"
                @select-change="sourceChange"
              />
            </template>
          </page-select-groups>
          <!-- 导出报表按钮 -->
          <div class="fan-search-col fan-search-right">
            <!-- 表格数据配置 -->
            <jr-columns-config
              :columnsKey="columnsKey"
              :tableColumn="tableColumn"
              :selectTableColumn="selectTableColumn"
              :recommendedColumn="recommendedColumn"
              @confirm="handleConfirm"
            />
            <template v-if="$has('FWS-SFKGL-FZD-DC')">
              <page-export-button
                title="分账单报表导出"
                exportServe="fin_receipt_divideReport"
                :total="total"
                :exportParams="exportParams"
                @close="onCloseExport"
                :customMain="true"
                :hasDate="false"
                trackCode="subAccountManageList-3"
              >
                <template v-slot:main>
                  <div style="margin-bottom: 10px">
                    <data-show label="导出报表类型:">
                      <el-radio-group v-model="divideType">
                        <el-radio :label="1">分账单</el-radio>
                        <el-radio :label="2">分账单明细</el-radio>
                      </el-radio-group>
                    </data-show>
                  </div>
                </template>
              </page-export-button>
            </template>
          </div>
        </div>
      </template>
      <template #main="{ height }">
        <jr-table
          :height="height"
          :key="height"
          :loading="loading"
          :tableData="list"
          :tableColumn="selectTableColumn"
          ref="subAccountManageRef"
        >
          <template v-slot:orderNumber="{row}">
            <jr-tooltip :content="row.orderNumber" type="popover" :is-filter="true" />
          </template>
        </jr-table>
      </template>
      <template #ffooter>
        <pagination
          :total="total"
          :current-page="queryForm.page"
          :size="queryForm.limit"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        />
      </template>
    </app-page>
    <!-- 详情 -->
    <detail
      :visible.sync="isDetailShow"
      :divide-no.sync="divideNo"
      @refresh="getList"
    />
    <!-- 批量搜索 -->
    <batch-search
      :visible.sync="isBatchSearchShow"
      :type-list="batchSearchTypeList"
      :loading="loading"
      @confirm="handleBatchSearchConfirm"
      trackCode="subAccountManageList-2"
    />
  </div>
</template>

<script>
import * as _ from 'lodash';
import { getDivideBopList, divideRetry } from '@/api/receivables/sub-account';
import detail from './components/detail';
import { setStatusColor } from '@/filters/index';

const queryFormDefault = {
  beginTime: '', // 开始时间
  endTime: '', // 结束时间
  page: 1,
  limit: 20,
  searchContent: '', // 搜索值
  searchType: '1',
  divideStatus: '', // 分账单状态
  approved: true, // 是否审核通过; true：分账单管理列表，空/false：分账审核列表
  transType: 2, // 1自营 2服务商
  timeType: '1',
};

export default {
  name: 'subAccountManageList',
  components: { detail },
  computed: {
    selectWayOptions() {
      const { dictData = {} } = this.$store.state.dictionary;
      const arr = _.cloneDeep(dictData.PAYMENT_FS) || [];
      arr.unshift({
        value: 'all',
        label: '全部',
      });
      return arr;
    },
    exportParams() {
      const params = {
        ...this.queryForm,
        exportDivideType: this.divideType,
        sourceList: this.sourceList,
      };
      delete params.page;
      delete params.limit;
      return params;
    },
  },
  data() {
    const list = [
      { value: '1', label: '业务订单编号' },
      { value: '2', label: '分账申请编号' },
      { value: '3', label: '分账单编号' },
      { value: '4', label: '客户名称' },
      { value: '5', label: '客户编号' },
      { value: '6', label: '业务主体' },
    ];
    return {
      divideType: 1, // 报表导出的类型
      loading: false,
      queryForm: JSON.parse(JSON.stringify(queryFormDefault)),
      list: [],
      total: 0,
      formList: [
        {
          prop: 'timeType',
          component: 'select-date-picker',
          options: [
            { label: '创建时间', value: '1' },
            { label: '分账时间', value: '2' },
          ],
        },
        {
          prop: 'searchType',
          contentProp: 'searchContent',
          component: 'search-input-select',
          attrs: {
            type: 'text',
            placeholder: '请输入内容',
          },
          options: [...list],
        },
      ],
      isDetailShow: false, // 详情弹窗
      divideNo: '', // 收款单编号
      /** ------批量搜索---- */
      batchSearchTypeList: [...list], // 批量搜索搜索条件集合
      isBatchSearchShow: false, // 批量搜索
      isBatch: false, // 是否批量操作
      tableColumn: [
        {
          prop: 'divideNo',
          label: '分账单编号',
          minWidth: '1',
          permission: 'FWS-SFKGL-FZD-XQ',
          disabled: true,
          trackCode: 'subAccountManageList-4',
          click: (row) => {
            this.handleDetail(row);
          },
        },
        { prop: 'orderNumber', label: '业务订单编号', minWidth: '1', slotName: 'orderNumber' },
        { prop: 'divideApplyNo', label: '分账申请编号', minWidth: '1' },
        { prop: 'businessNo', label: '客户编号', minWidth: '1' },
        { prop: 'businessName', label: '客户名称', minWidth: '1' },
        { prop: 'payeeBusinessName', label: '业务主体', minWidth: '1' },
        { prop: 'divideAmount', label: '分账金额(元)', minWidth: '1', filterName: 'toFenThousandsAndFloat', disabled: true },
        { label: '归属业务', prop: 'busiSourceDesc', minWidth: '1' },
        { prop: 'createTime', label: '创建时间', minWidth: '1', filterName: 'formatTime', disabled: true },
        { prop: 'createUser', label: '分账申请人', minWidth: '1' },
        { prop: 'approvalUser', label: '分账审核人', minWidth: '1' },
        {
          label: '状态',
          prop: 'divideStatus',
          status: 'divideStatus',
          statusDesc: 'divideStatusDesc',
          disabled: true,
          statusColor: (val) => setStatusColor(val, 'divideStatus'),
        },
        {
          label: '操作',
          prop: 'operate',
          disabled: true,
          show: () => this.$has('FWS-SFKGL-FZD-CS'),
          width: '100px',
          btnGroups: [
            {
              name: '重试',
              showBtn: (row) => this.$has('FWS-SFKGL-FZD-CS') && [-1, 3].includes(row.divideStatus),
              className: ['table-button', 'table-button-primary'],
              trackCode: 'subAccountManageList-5',
              click: (row) => this.handleTry(row),
            },
          ],
        },
      ],
      sourceList: [], // 归属业务
      columnsKey: 'fwsSubAccountManageList',
      recommendedColumn: [
        { prop: 'finishTime', label: '分账时间', minWidth: '1', filterName: 'formatTime' },
      ],
      selectTableColumn: [],
      selectList: [
        {
          title: '分账单状态',
          prop: 'divideStatus',
          dictionaryPath: '/finance/finance-receipt/FinDivideStatusEnum',
        },
        {
          slotName: 'sourceList',
        },
      ],
    };
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      this.$store.dispatch('dictionary/getDictionary', { type: 'PAYMENT_FS' });
      try {
        const list = await this.$store.dispatch('dictionary/getUserTemplate', {
          pageKeys: [this.columnsKey],
          columnsKey: this.columnsKey,
          tableColumn: this.tableColumn,
          recommendedColumn: this.recommendedColumn,
        });
        this.selectTableColumn = list;
      } catch (error) {
        this.selectTableColumn = this.tableColumn;
      }
      this.getList();
    },
    // 配置确认
    handleConfirm(values) {
      this.selectTableColumn = values;
      this.$nextTick(() => {
        this.$refs.subAccountManageRef.doLayout();
      });
    },
    // 批量查询提交
    handleBatchSearchConfirm(form) {
      const param = { ...queryFormDefault };
      param.searchType = form.searchType || '';
      param.searchContent = (form.list || []).join(',');
      this.queryForm = { ...param };
      this.getDivideBopList(param, true);
    },
    // 批量查询弹窗
    handleBatchSearch() {
      this.isBatchSearchShow = true;
    },
    // 详情
    handleDetail(row) {
      this.divideNo = row?.divideNo || '';
      this.isDetailShow = true;
    },

    // 分页操作
    handleCurrentChange(page) {
      this.queryForm.page = page;
      this.getList();
    },
    handleSizeChange(limit) {
      this.queryForm.page = 1;
      this.queryForm.limit = limit;
      this.getList();
    },

    // 列表查询
    handleSearch(params = {}) {
      this.queryForm = { ...this.queryForm, ...params, page: 1 };
      this.getList();
    },
    // 列表查询
    getList() {
      this.getDivideBopList(this.queryForm);
    },
    // 列表接口请求
    async getDivideBopList(param, isBatch = false) {
      try {
        this.isBatch = isBatch;
        this.loading = true;
        this.list = [];
        const res = await getDivideBopList({ ...param, sourceList: this.sourceList });
        this.total = res.totalCount || 0;
        this.list = res.data || [];
        this.isBatchSearchShow = false; // 批量搜索弹窗关闭
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    // 重置搜索条件
    handleReset() {
      this.queryForm = JSON.parse(JSON.stringify(queryFormDefault));
      this.payWays = ['all', '-1'];
      this.shareScopeEnd = [['all', '-1']];
      this.sourceList = [];
      this.getList();
    },
    sourceChange(list) {
      this.sourceList = [...list];
      this.refreshList();
    },
    refreshList() {
      this.queryForm.page = 1;
      this.getList();
    },
    // 关闭导出弹窗
    onCloseExport() {
      this.divideType = 1;
    },
    handleTry(row) {
      this.$confirm('是否重新发起分账申请？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(async () => {
        console.log(row);
        await divideRetry({ divideNo: row.divideNo });
        this.$message.success('操作成功');
        this.getList();
      });
    },
  },
};
</script>
